<template>
    <CModal
      :title="title"
      :color="color"
      :show.sync="localTaxModal"
    >   
        <CForm>
            <CRow>
              <CCol md="6">
                <CSelect
                  label="Tipo:"
                  :isValid="checkIfValid('type')"
                  :value.sync="$v.form.type.$model"
                  :options="typesOptions"
                  invalidFeedback="Este campo es requerido."
                  @change="changeType"
                />
              </CCol>
              <CCol md="6">
                <CInput
                  label="Tasa (%):"
                  :lazy="false"
                  :value.sync="$v.form.rate.$model"
                  :isValid="checkIfValid('rate')"
                  placeholder=""
                  autocomplete="rate"
                  invalidFeedback="Este campo es requerido."
              />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <CInput
                  label="Nombre:"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  placeholder=""
                  autocomplete="name"
                  invalidFeedback="Este campo es requerido."
              />
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store" :color="color">Aceptar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, maxLength, integer, email} from "vuelidate/lib/validators"

export default { 
  name: 'LocalTaxModal',
  props: {

  },
  
  data () {
    return {
      localTaxModal: false,
      title: "Nuevo Impuesto Local", 
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      typesOptions: [{label: 'Traslado', value: 'TRASLADO'}, {label: 'Retención', value: 'RETENCION'}]
    }
  },
  methods: {
    async changeType () {

    },
    storeModal () {
      this.localTaxModal = true;
      this.color = "info";
      this.title = 'Nuevo Impuesto Local';
      this.isEdit = false;
      this.submitted = false;
      this.form = this.getEmptyForm();
    },
    updateModal (item) {
      this.localTaxModal = true;
      this.color = "warning";
      this.title = 'Editar Impuesto Local';
      this.isEdit = true;
      this.submitted = false;

      this.form = {
          id: item.id,
          type: item.type,
          name: item.name,
          rate: (item.rate * 100).toFixed(4)
      };
    },
    store () {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        if(this.form.id > 0){
          this.$emit("update", this.form );
        }
        else{
          this.$emit("store", this.form );
        }

        this.closeModal();
      }
    },
    closeModal () {
      this.localTaxModal = false;

      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          type: 'TRASLADO',
          name: '',
          rate: '',
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid)
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      rate: {
        required
      },
      type: {
        required
      },
      name: {
        required
      }
    }
  },
}
</script>